import {
  arrayBuilderItemSubsequentPageTitleUI,
  descriptionUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import MedicareCardDescription from '../../components/FormDescriptions/MedicareCardDescription';
import { MedicarePartADescription } from '../../components/FormDescriptions/MedicarePlanDescriptions';
import { attachmentSchema, attachmentUI } from '../../definitions';
import content from '../../locales/en/content.json';
import { ATTACHMENT_IDS } from '../../utils/constants';

const TITLE_TEXT = content['medicare--part-a-card-title'];
const INPUT_LABELS = {
  cardFront: content['medicare--part-a-card-label--front'],
  cardBack: content['medicare--part-a-card-label--back'],
};
const HINT_TEXT = content['attachments--hint-text'];

export default {
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(
      TITLE_TEXT,
      MedicarePartADescription,
    ),
    ...descriptionUI(MedicareCardDescription({ variant: 'partA' })),
    medicarePartAFrontCard: attachmentUI({
      title: INPUT_LABELS.cardFront,
      attachmentId: ATTACHMENT_IDS.medicareAbCardFront,
    }),
    medicarePartABackCard: attachmentUI({
      title: INPUT_LABELS.cardBack,
      hint: HINT_TEXT,
      attachmentId: ATTACHMENT_IDS.medicareAbCardBack,
    }),
  },
  schema: {
    type: 'object',
    required: ['medicarePartAFrontCard', 'medicarePartABackCard'],
    properties: {
      medicarePartAFrontCard: attachmentSchema,
      medicarePartABackCard: attachmentSchema,
    },
  },
};
